import toast from "@/services/Notification";
import HTTP from "@/_helpers/http";

// State
const state = {
    ssoUrl: null,
    isLoading: false,
    error: null,
};

// Getters
const getters = {};

// Mutations
const mutations = {
    SET_LOADING(state, isLoading) {
        state.isLoading = isLoading;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
    SET_SSO_URL(state, url) {
        state.ssoUrl = url;
    },
};

// Actions
const actions = {
    async switchToClientPanel({ commit }) {
        commit('SET_LOADING', true);
        commit('SET_ERROR', null);

        try {
            const response = await HTTP().get('/switch-to-client');

            if (response.status === 200 && response.data.type === 'success') {
                window.location.href = response.data.ssoUrl;
            } else {
                commit('SET_ERROR', response.data.message || 'Failed to switch panel');
                toast.error(response.data.message || 'Failed to switch panel');
            }
        } catch (error) {
            console.error(error);
            commit('SET_ERROR', 'Please login again or go to client');
            toast.error('Please login again or go to client');
        } finally {
            commit('SET_LOADING', false);
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};